const baseApi = {
  GETBASEDATALIST: '/innovationBase/getApplys', //获取所有的基地data
  DELETEITEM: '/innovationBase/deleteApply', //删除基地申请的某一项
  UPDATEBASIITTEM: '/innovationBase/updateStatus', //更新状态
  selectApplyUser: '/applyUser/selectApplyUser', //入校申请查询
  deleteApplyUser: '/applyUser/deleteApplyUser', //删除
  recordExport: '/applyUser/recordExport', //导出
}
export default baseApi